import React, { useEffect, useState } from "react";
import '../../StoreDashboard/style.css';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import ImagePicker from '../../../../components/LoginFormComponents/ImagePicker';
import PostRequest from '../../../../service/PostRequest';
import registrationIcon from '../../../../assets/icons/store-registration.svg';
import ProfileIntiationLablesContainer from "../../../../components/DashboardComponents/ProfileIntiationLablesContainer";
import FormSeperator from "../../../../components/LoginFormComponents/FormSeperator";
import GetRequest from "../../../../service/GetRequest";
import { Button } from 'primereact/button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TemplateSelectionCard from "../../../../components/Widgets/Cards/TemplateSelectionCard";
import InputSelectionDropdown from "../../../../components/Widgets/Inputs/InputSelectionDropdown";
import InputFeildTextArea from "../../../../components/Widgets/Inputs/InputFeildTextArea";
import InputFieldText from "../../../../components/Widgets/Inputs/InputFieldText";

const RegisterStorePage = ({setActivePath}) => {


    const navigate = useNavigate();

    const [templates, setTemplates] = useState([]);
    const [templateChosePopupopen, setTemplateChosePopupOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null); // New state variable
    const [error, setError] = useState(false);


    // List of reserved keywords
const reservedKeywords = [
  "m2r2", "beta", "www", "ftp", "mail", "ns1", "ns2", "smtp", "pop", "imap", "admin",
  "administrator", "root", "hostmaster", "webmaster", "postmaster", "support", "help",
  "login", "test", "staging", "dev", "development", "alpha", "demo", "docs", "api",
  "secure", "status", "about", "info", "register", "signup", "signin", "user", "users",
  "client", "clients", "customer", "customers", "service", "services", "account",
  "accounts", "pay", "payment", "payments", "billing", "invoice", "shop", "store",
  // Add more keywords as necessary
  "api-key", "token", "auth", "authorization", "oauth", "oauth2", "sso", "logout", 
  "session", "sessions", "config", "configuration", "secret", "secrets", "admin-panel", 
  "control-panel", "panel", "cpanel", "whm", "server", "servers", "database", "databases",
  "db", "manage", "management", "monitor", "monitoring", "logs", "logging", "report", 
  "reports", "analytics", "metric", "metrics", "dashboard", "sys", "system", "network", 
  "net", "node", "nodes", "cluster", "clusters", "kube", "kubernetes", "docker", 
  "container", "containers", "vps", "cloud", "cdn", "dns", "dns1", "dns2", "resolver", 
  "proxy", "proxies", "cache", "caching", "load", "loadbalancer", "lb", "gateway", 
  "gateways", "vpn", "firewall", "firewalls", "endpoint", "endpoints", "security", 
  "secure", "malware", "virus", "viruses", "spam", "spammer", "phish", "phishing", 
  "attack", "attacks", "exploit", "exploits", "hacker", "hackers", "bot", "bots", 
  "botnet", "botnets"
];



    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 670,
      bgcolor: 'var(--surface-card)',
      boxShadow: 15,
      p: 4,
    };


  const fontNames = [
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Georgia",
    "Roboto",
    "Open Sans",
    "Lato",
    "Montserrat",
    "Roboto Slab",
    "Merriweather"
  ];

  const bussinessTypeOptions = [
    { value: 'E-commerce', label: 'Ecommerce' },
    { value: 'Electronics', label: 'Electronics' },
    { value: 'Hotel', label: 'Hotel' },
    { value: 'Restaurant', label: 'Restaurant' },
    { value: 'Pharmacy', label: 'Pharmacy' },
    { value: 'Textiles', label: 'Textiles' },
    { value: 'Jewellery', label: 'Jewellery' },
    { value: 'Apparel', label: 'Apparel' },
    // Add more options as needed
];

  const [brandName,setBrandName ] = useState("");
  const [brandNameError, setBrandNameError] = useState(null);
  const [tagline,setTagline ] = useState("");
  const [description,setDescription ] = useState("");
  const [bussinessType,setBussinessType ] = useState("");
  const [template, setTemplate] = useState(null);
  const [theme,setTheme ] = useState("#000000");
  const [font,setFont ] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false); // State to hold checkbox value
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageChange = (imageDataUrl) => {
    setSelectedImage(imageDataUrl);
  };

  

  // Function to handle checkbox change
  const handleCheckboxChange = (event) => {
    const newValue = event.target.checked; // Get the new value of the checkbox
    setIsDarkMode(newValue); // Update the state
    // You can perform any additional actions here based on the new checkbox state
  };



  const handleBrandnameChange = (e) => {
    const value = e.target.value;
    setBrandName(value);
        // Check if the input value contains any reserved keyword
        const containsReservedKeyword = reservedKeywords.includes(value.toLowerCase());
    setError(containsReservedKeyword);
  };

  const handleTaglineChange = (e) => {
    setTagline(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleBussinessTypeChange = (e) => {
    setBussinessType(e.target.value);
  };

  const handleThemeChange = (e) => {
    setTheme(e.target.value);
  };
  const handleFontChange = (e) => {
    setFont(e.target.value);
  };
  
  const handleClose = () => {
    setTemplateChosePopupOpen(false);
  };

      const chooseTemplate = () => {
      setTemplate(selectedTemplate);
      handleClose();
        };

    const handleTemplateSelect = (template) => {
      setSelectedTemplate(template); // Update selected template
      setTemplateChosePopupOpen(true); // Open modal
    };

  const handleAddStorePostRequest = async () => {
    let isValid = true;

    if (brandName) {
      try {
        const response = await GetRequest(`v1/store-management-service/validate/store?name=${brandName}`,true);
        if (response===true) {
          setBrandNameError("Brand Name is already taken. choose a different one");
          isValid = false;
        } else {
          setBrandNameError(null);
        }
      } finally {
        setTimeout(() => {
          setBrandNameError(null);
        }, 5000);
      }
    }

    const data = {
      brandName: brandName,
      tagline: tagline,
      brandDescription: description,
      brandTheme: theme,
      businessType: bussinessType,
      brandFont: font,
      uiTheme: "true",
    };
    console.log("the registered data is",data);
    if (isValid) {
        try {
          const response = await PostRequest('v1/store-management-service/create/store?templateId='+template.id, data, true);
          console.log(response);
          if (response === undefined) {
            console.log("Store registration failed");
          } else {
            console.log("Store registered");
            navigate("/store/complete/profile"); 
          }
        } catch (error) {
          console.error("Store Creation failed:", error);
        }
      }
  }
 
  useEffect(() => {
    setActivePath("Dashboard");

    GetRequest("v1/store-management-service/view/all/templates")
            .then(response => {
                if (!response || response === undefined) {
                    console.log("No Templates found");
                } else {
                    console.log(response);
                    setTemplates(response);
                }
            })
            .catch(error => {
                console.error("Error fetching templates:", error);
            });
  }, [setActivePath]);

    

    return (
            <div className="outlet-container">
              <div className="background-white">
                <div className="background-white-sub-container">
                  <br/>
                <ProfileIntiationLablesContainer title="Register Store" description="Add store details like color, font theme etc" status={true}  icon={registrationIcon} iconBackgroundColor="#CE7B69"  />

                <div className="flex gap-5 justify-between self-start mt-5 font-medium">
            <div className="flex flex-col justify-center px-2.5 py-3 text-xs whitespace-nowrap rounded-sm border border-black border-solid text-neutral-600">
              <ImagePicker image={selectedImage} handleInputChange={handleImageChange}/>
            </div>
            <div className="flex flex-col my-auto">
            <div className="text-base">Brand Logo</div>
              <div className="mt-1.5 text-xs text-sky-500">
                (<span className="text-sky-500">Downloads/logo.png</span>) selected
              </div>
            </div>
          </div> 
                  
          <FormSeperator content="Basic Details"/>
          <InputFieldText value={brandName} onChange={handleBrandnameChange} label="Enter the Shop/Brand name" errorMessage={brandNameError}/>
          {error && <p style={{ color: 'red', marginLeft: '210px',marginTop: '0px' }}>The brand name contains a reserved keyword. Please choose another name.</p>}
          <InputFieldText value={tagline} onChange={handleTaglineChange} label= "Enter the Tagline" errorMessage={brandNameError}/>

          <InputSelectionDropdown 
                value={bussinessType}
                onChange={handleBussinessTypeChange}
                options={bussinessTypeOptions}
                optionLabel="label" 
                placeholder="Choose your Bussiness type" 
            />
            
        <InputFeildTextArea value={description} onChange={handleDescriptionChange} label="Enter description for your shop/brand"/>
        <FormSeperator content="Choose a Template"/>

          <Modal
              open={templateChosePopupopen}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Selected template
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {selectedTemplate && (
                          <iframe title="theme" src={selectedTemplate.demoURL} style={{ width: '600px', height: '300px', overflow: 'hidden' }}></iframe>
                        )}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <div className='flex-input-container'>
              <Button label="Select Template" onClick={chooseTemplate}/>
              <Button label="Close" onClick={handleClose}/>
              </div>
            </Typography>
          </Box>
        </Modal>
<br/>
<div className='flex-input-container'>
        {templates.map((template, index) => (
          <TemplateSelectionCard
              key={index}
              template={template}
              index={index}
              handleTemplateSelect={handleTemplateSelect}
              isSelected={selectedTemplate && selectedTemplate.id === template.id}
        />
        ))}</div>
      <br/>  
        <FormSeperator content="User Interface Details"/>


          <div className='flex-input-container'>
            <div className="flex flex-col">
                <div className="grow my-auto">Choose Bussiness Theme</div>
                <input type="color" id="color" name="color" value={theme} onChange={handleThemeChange} className="shrink-0 bg-teal-600 rounded border-0 border-black border-solid h-[30px] w-[30px]"/>
              </div>
             
              <InputSelectionDropdown 
                  value={font}
                  onChange={handleFontChange}
                  options={fontNames.map(font => ({ value: font, label: font }))}
                  optionLabel="label" 
                  placeholder="Choose your Bussiness font" 
                  />
               
               </div>
         
         
              Default Mode :  <label class="switch">
                                <input type="checkbox" value={isDarkMode} onChange={handleCheckboxChange}/>
                                <span class="slider"></span>
                              </label>
            
            <div className="centralised-text">
          <div onClick={handleAddStorePostRequest} className="justify-center items-center flex cursor-pointer px-16 py-4 mt-10 max-w-full text-lg font-medium text-white bg-sky-500 rounded-lg w-[379px] max-md:px-5 hover:bg-black hover:text-white transition duration-300 ease-in-out">
  Save and Continue
</div>     </div></div>
        </div></div>
      );
}

export default RegisterStorePage





